let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gTfr7")).then(() => parcelRequire('dNajn'));